import { Loading } from '@common_components/loading.component';

export const LoadingDocViewer = () => {
  return <Loading size={ 64 }/>;
};